export default "__VITE_ASSET__CqjEsm2e__"